import { BREAKPOINTS } from './constants'

/** Two layouts only. iPads and laptops get the same desktop layout. */
export type Layout = 'phone' | 'desktop'
export type Mode = 'shop' | 'plan'

export const layoutFor = (width: number): Layout => (width >= BREAKPOINTS.desktop ? 'desktop' : 'phone')

/** Nobody shops with an iPad or a laptop: only the phone has shopping mode and its basket (components/shopping). */
export const modeFor = (layout: Layout): Mode => (layout === 'phone' ? 'shop' : 'plan')


type Spec = {
  mode: Mode
  sidebar: boolean
  quickAdd: 'dock' | 'top'
  inlineAddPerCategory: boolean
  showEmptyCategories: boolean
  editor: 'sheet' | 'dialog'
  chips: 'scroll' | 'wrap'
  progress: 'basket-segments' | 'category-split'
}

/** What each layout shows. Rendering is the app's job; desktop is the phone's list in one wider column (styles/plan.css). */
export const LAYOUT_SPEC: Record<Layout, Spec> = {
  phone: { mode: 'shop', sidebar: false, quickAdd: 'dock', inlineAddPerCategory: false, showEmptyCategories: false, editor: 'sheet', chips: 'scroll', progress: 'basket-segments' },
  desktop: { mode: 'plan', sidebar: true, quickAdd: 'top', inlineAddPerCategory: false, showEmptyCategories: false, editor: 'dialog', chips: 'wrap', progress: 'category-split' },
}
